<template>
  <v-container>
    <h2 class="text-h6">{{ $t("For your") }} <span class="font-weight-bold">{{ $t("{price} annual subscription", {price: subscriptionPrice}) }}</span> {{ $t("you will get") }}:</h2>
    <h3 class="text-subtitle-1 mb-2">{{ $t("A free bundle worth {price}", {price: bundlePrice}) }}</h3>

    <ul class="mb-6 text-body-1">
      <li>{{ $t("{quantity} iron on labels", {quantity: '25'}) }}</li>
      <li>{{ $t("{quantity} sticker labels", {quantity: '25'}) }}</li>
      <li>{{ $t("{quantity} key tags", {quantity: '3'}) }}</li>
      <li>{{ $t("{quantity} two part bag tag", {quantity: '1'}) }}</li>
      <li>{{ $t("{quantity} recovery card", {quantity: '1'}) }}</li>
    </ul>

    <h3 class="text-subtitle-1 mb-2">{{ $t('headings.Also includes') }}</h3>
    <ul class="mb-6 text-body-1">
      <li>{{ $t("Unlimited SMS notifications for found items") }}</li>
      <li>{{ $t("Refer a friend commission") }}</li>
      <li>{{ $t("Free use of our app (android/ios)") }}</li>
      <li>{{ $t("Optional partner offers (opt in)") }}</li>
    </ul>
  </v-container>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "IndividualsSummary",
  computed: {
    ...mapState({
      brand: state => state.brand,
brandName: state => state.brandName
    }),
    bundlePrice() {
      if (this.brand === 'neotag') {

        return '€' + process.env.VUE_APP_BUNDLE_EUR
      }

      return '£' + process.env.VUE_APP_BUNDLE_GBP
    },
    subscriptionPrice() {
      if (this.brand === 'neotag') {
        return '€' + process.env.VUE_APP_SUBSCRIPTION_EUR
      }

      return '£' + process.env.VUE_APP_SUBSCRIPTION_GBP
    }
  }
}
</script>

<style scoped>

</style>
